import { AsterixOutlined } from '@icon';
import { capitalizeFirstLetter } from '@lib/utils/strings';
import React from 'react';
import { useTheme } from 'styled-components';
import Text from '../../../../../typography';
import { fieldClasses } from '../../FormField.styled';
import FormFeedback from '../form-feedback';
import FormTooltip from '../form-tooltip';
import { AsteriskWrapper, HeaderWrapper, LabelWrapper } from './form-header.styled';

interface FormHeaderProps {
  required?: boolean;
  status?: 'error' | 'success';
  label?: string;
  name: string;
  showFeedback?: boolean;
  tooltip?: string;
}

const FormHeader: React.FunctionComponent<FormHeaderProps> = ({
  required,
  status,
  label,
  showFeedback,
  name,
  tooltip,
}) => {
  const theme = useTheme();
  const hasError = status === 'error';

  return (
    <HeaderWrapper className={fieldClasses.header}>
      <LabelWrapper>
        <AsteriskWrapper>
          {required ? <AsterixOutlined color={theme.color.solid.error} width={16} /> : null}
        </AsteriskWrapper>
        <Text
          // @ts-expect-error
          htmlFor={name}
          as="label"
          display="captionLarge"
          variant="default"
          style={{
            color: hasError ? theme.color.tint.error : theme.color.tint.secondary,
          }}
        >
          {label ? capitalizeFirstLetter(label) : null}
        </Text>
        {tooltip ? <FormTooltip tooltipText={tooltip} /> : null}
      </LabelWrapper>
      {showFeedback || status ? <FormFeedback status={status} /> : null}
    </HeaderWrapper>
  );
};

export default React.memo(FormHeader);
